export default __webpack_public_path__ + "static/8-01140640643d21b4b7e002aa5918de0c.jpg";